import React from 'react';
import { Box, Container, SimpleGrid, VStack, Text, Icon } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const WhyUsStats = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="brand.800">
      <Container maxW="container.xl">
        <SimpleGrid columns={{ base: 2, md: 4 }} spacing={8}>
          {data.items.map((stat, index) => (
            <MotionBox
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <VStack spacing={3} color="white">
                <Icon as={stat.icon} boxSize={10} color="accent.gold" />
                <Text fontWeight="900" fontSize="4xl">
                  {stat.value}
                </Text>
                <Text fontSize="sm" opacity={0.8} textAlign="center">
                  {stat.label}
                </Text>
              </VStack>
            </MotionBox>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default WhyUsStats;